import { render, staticRenderFns } from "./SentimentChangeAlert.vue?vue&type=template&id=2e93e536&scoped=true&"
import script from "./SentimentChangeAlert.vue?vue&type=script&lang=js&"
export * from "./SentimentChangeAlert.vue?vue&type=script&lang=js&"
import style0 from "./SentimentChangeAlert.vue?vue&type=style&index=0&id=2e93e536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93e536",
  null
  
)

export default component.exports